import ReactSwitch from 'react-switch';
import BootstrapSpinner from 'react-bootstrap/Spinner';
import { useSelector } from 'react-redux';
import { getShouldUseAttestation } from '../../../../growthbook';
import {
  useDentistDsoAttestationToggle,
  getDsoCodesFromRemoteConfig,
} from '../hooks/useDentistBenevisAttestationToggle';
import { formatDsoName } from '../../../../utils/String';

const DentistDsoAttestationToggle = ({ officeId, dsoCode }) => {
  const { isEnabled, isLoading, onToggle } =
    useDentistDsoAttestationToggle(officeId, dsoCode);
  const displayName = formatDsoName(dsoCode);

  return (
    <div
      style={{
        width: '100%',
        padding: '5px 10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <p className="card-text" style={{ fontWeight: '600' }}>
        Allow {displayName} Attestation:
      </p>
      {isLoading ? (
        <BootstrapSpinner
          animation="border"
          role="status"
          variant="info"
          style={{
            height: 20,
            width: 20,
          }}
        />
      ) : (
        <ReactSwitch
          checked={isEnabled}
          onChange={onToggle}
          onColor="#34C9EB"
          onHandleColor="#fff"
          handleDiameter={20}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0 0 1px 10px rgba(0, 0, 0, 0.2)"
          height={25}
          width={50}
          className="react-switch"
          id={`attestation-switch-${dsoCode}`}
        />
      )}
    </div>
  );
};

export const DentistAttestationCard = ({ officeId }) => {
  const currentUser = useSelector(
    (state) => state.users.currentUser,
  );
  const dsoCodes = getDsoCodesFromRemoteConfig();
  const userDso = currentUser?.dsoName;

  if (
    !getShouldUseAttestation()
    || !userDso
    || !dsoCodes.includes(userDso)
  ) {
    return null;
  }

  return (
    <div className="card mt-2">
      <div className="card-body">
        <div
          style={{
            width: '100%',
            alignSelf: 'center',
            paddingInline: '5%',
          }}
        >
          <div
            className="card border-0"
            style={{ marginBottom: 30 }}
          >
            <h3
              className="card-title"
              style={{ textAlign: 'center' }}
            >
              {formatDsoName(userDso)} Attestation
            </h3>
          </div>
          <DentistDsoAttestationToggle
            officeId={officeId}
            dsoCode={userDso}
          />
        </div>
      </div>
    </div>
  );
};
